@file:OptIn(InternalResourceApi::class)

package ifaandroid.feature.profile.log_food.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.feature.profile.log_food.generated.resources/"

@delegate:ResourceContentHash(-1_526_434_723)
internal val Res.drawable.ic_barcode_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_barcode_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_barcode_24.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_847_172_469)
internal val Res.drawable.ic_keyboard_hide_24: DrawableResource by lazy {
      DrawableResource("drawable:ic_keyboard_hide_24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_keyboard_hide_24.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_barcode_24", Res.drawable.ic_barcode_24)
  map.put("ic_keyboard_hide_24", Res.drawable.ic_keyboard_hide_24)
}
